import { API_BASE } from '@/config'

/**
 * 获取资源的完整 URL
 * @param {string} url 资源相对路径或完整URL
 * @returns {string} 完整URL
 */
export function getFullUrl(url) {
  if (!url) return ''
  if (url.startsWith('http://') || url.startsWith('https://')) return url
  const path = url.startsWith('/') ? url : '/' + url
  // 开发环境（localhost / 127.0.0.1）走 devServer 代理，保持相对路径；
  // 生产环境统一拼接到后端域名，避免后台部署在独立子域时 /uploads 未被代理导致 404。
  // 注意：不依赖 process.env.NODE_ENV，因为部分构建产物中该值未被正确替换。
  const isDev = typeof window !== 'undefined' &&
    (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')
  if (isDev) {
    return path
  }
  return API_BASE + path
}

/**
 * 格式化秒数为可读时长
 * @param {number} seconds 秒数
 * @returns {string} 格式化后的时长，如 "1小时30分钟20秒"
 */
export function formatDuration(seconds) {
  if (!seconds || seconds <= 0) return '0秒'
  const h = Math.floor(seconds / 3600)
  const m = Math.floor((seconds % 3600) / 60)
  const s = Math.floor(seconds % 60)
  let result = ''
  if (h > 0) result += h + '小时'
  if (m > 0) result += m + '分钟'
  if (s > 0) result += s + '秒'
  return result || '0秒'
}

/**
 * 格式化日期字符串
 * @param {string|Date} date 日期
 * @param {string} fmt 格式，默认 'YYYY-MM-DD HH:mm:ss'
 * @returns {string} 格式化后的日期
 */
export function formatDate(date, fmt = 'YYYY-MM-DD HH:mm:ss') {
  if (!date) return ''
  const d = new Date(date)
  if (isNaN(d.getTime())) return ''
  const map = {
    'YYYY': d.getFullYear(),
    'MM': String(d.getMonth() + 1).padStart(2, '0'),
    'DD': String(d.getDate()).padStart(2, '0'),
    'HH': String(d.getHours()).padStart(2, '0'),
    'mm': String(d.getMinutes()).padStart(2, '0'),
    'ss': String(d.getSeconds()).padStart(2, '0')
  }
  let result = fmt
  for (const [key, value] of Object.entries(map)) {
    result = result.replace(key, value)
  }
  return result
}
